// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iJ8zxQxIQ76DfLnPEf6oAA\\=\\={display:flex;align-items:center}.iJ8zxQxIQ76DfLnPEf6oAA\\=\\= div[data-qa=checkbox]{max-width:max-content !important;margin-right:var(--xds-spacing-b)}", "",{"version":3,"sources":["webpack://./src/shared/components/PIECheckbox/PIECheckbox.module.scss"],"names":[],"mappings":"AAAA,4BAEI,YAAA,CACA,kBAAA,CACA,kDACI,gCAAA,CACA,iCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PIECheckboxContainer": "iJ8zxQxIQ76DfLnPEf6oAA=="
};
export default ___CSS_LOADER_EXPORT___;
